export default __webpack_public_path__ + "static/media/12.b5f4023f.jpg";